/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_GenderInputs */

const en__field_gender = /** @type {(inputs: _Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender`)
};

const de__field_gender = /** @type {(inputs: _Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlecht`)
};

/**
* | output |
* | --- |
* | "Gender" |
*
* @param {_Field_GenderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_gender = /** @type {((inputs?: _Field_GenderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_GenderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_gender(inputs)
	return de__field_gender(inputs)
});